import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { AuthContext } from './components/user/AuthProvider';

// Parse the roles stored in localStorage (stored as a comma-joined string,
// e.g. "admin" or "staff,buyer") into a normalized array.
const getCurrentRoles = () =>
  (localStorage.getItem('roles') || '')
    .split(',')
    .map((r) => r.trim().toLowerCase())
    .filter(Boolean);

const getCurrentGroups = () => {
  try {
    return (JSON.parse(localStorage.getItem('groups') || '[]') || [])
      .map((g) => String(g).trim().toLowerCase())
      .filter(Boolean);
  } catch {
    return [];
  }
};

// Route guard that requires authentication AND an allowed role or group.
// `admin` can access every component, so it is always permitted.
const RoleRoute = ({ children, allowedRoles = [], allowedGroups = [] }) => {
  const { isAuthenticated } = useContext(AuthContext);
  const location = useLocation();

  if (!isAuthenticated) {
    localStorage.setItem('requestedPage', location.pathname + location.search);
    return <Navigate to="/login" />;
  }

  const roles = getCurrentRoles();
  const groups = getCurrentGroups();
  const permitted =
    roles.includes('admin') ||
    groups.includes('admin') ||
    allowedRoles.some((role) => roles.includes(role.toLowerCase())) ||
    allowedGroups.some((group) => groups.includes(group.toLowerCase()));

  if (!permitted) {
    // Authenticated but not authorized for this component.
    return <Navigate to="/" />;
  }

  return children;
};

export default RoleRoute;
